import cn from 'classnames';
import React from 'react';

import { ControlOptionProps } from 'editor/src/component/DesktopSidebar/TabContents/ProductTabContent/ProductControlContent/ProductControls/ProductControlProps';
import IconLoading from 'editor/src/component/Icon/IconLoading';

import styles from './index.module.scss';

interface Props extends ControlOptionProps {
  loading?: boolean;
}

function ButtonElement({ option, selected, disabled, toggle, control, loading }: Props) {
  return (
    <div
      className={cn(
        styles.ButtonElement,
        { [styles.selected]: selected, [styles.disabled]: disabled, 'cy-active': selected },
        `cy-button-${control.key}-${option.value}`,
      )}
      onClick={() => toggle(control, option)}
      aria-busy={loading || undefined}
    >
      {loading && <IconLoading className={cn(styles.loader, 'cy-button-loading')} />}
      {option.title}
    </div>
  );
}

export default React.memo(ButtonElement);
